import { useState } from 'react';
import { Stack } from '@chakra-ui/react';
import { Heading } from '@/components/v4';
import FieldTooltip from '@/components/forms/new/FieldToolTip';
import { headingStyling } from 'components/forms/new/formStyles';

const RequiredScopeHeader = ({ label }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Stack
            direction="row"
            alignItems="center"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Heading sx={headingStyling}>{label}</Heading>
            {isHovered && (
                <FieldTooltip
                    label="Required Scope"
                    ariaLabel="permissions-set-required-scope-tooltip"
                    left="25px"
                    bottom="5px"
                />
            )}
        </Stack>
    );
};

export default RequiredScopeHeader;
